import { alpha, SxProps, Theme } from '@mui/material';
import { PartnerBusinessState } from './partner-business-status.types';

const CLOSURE_NOTE_TINT_OPACITY = 0.13;

export function getPartnerBusinessStateColor(theme: Theme, state: PartnerBusinessState) {
  if (state === PartnerBusinessState.Open) {
    return theme.palette.custom.OV.extended.Essentials.color;
  }

  if (state === PartnerBusinessState.Holiday) {
    return theme.palette.custom.OV.extended.Signature.color;
  }

  return theme.palette.custom.OV.sys.onSurfaceVariant;
}

export const partnerStatusLineSx: SxProps<Theme> = {
  display: 'block',
  width: 'fit-content',
  marginTop: '0.0625rem',
  cursor: 'default',
  fontSize: 'inherit',
};

export const partnerStatusLabelSx = (state: PartnerBusinessState): SxProps<Theme> => ({
  fontWeight: 600,
  color: (theme: Theme) => getPartnerBusinessStateColor(theme, state),
});

export const partnerStatusHeadsUpSx: SxProps<Theme> = {
  fontWeight: 600,
  color: (theme: Theme) => theme.palette.custom.OV.extended.Signature.color,
};

export const hoursCardSx: SxProps<Theme> = {
  width: '15.5rem',
  padding: '0.625rem 0.75rem',
  borderRadius: '0.625rem',
  border: (theme: Theme) => `1px solid ${theme.palette.custom.OV.sys.outlineVariant}`,
  backgroundColor: (theme: Theme) => theme.palette.custom.OV.sys.surfaceContainerLow,
  boxShadow: (theme: Theme) => theme.shadows[6],
};

export const hoursCardHeadlineSx = (state: PartnerBusinessState): SxProps<Theme> => ({
  fontSize: '0.75rem',
  fontWeight: 600,
  marginBottom: '0.5rem',
  color: (theme: Theme) => getPartnerBusinessStateColor(theme, state),
});

export const closureNoteSx: SxProps<Theme> = {
  padding: '0.5rem 0.625rem',
  borderRadius: '0.5rem',
  marginBottom: '0.5625rem',
  fontSize: '0.71875rem',
  lineHeight: 1.5,
  fontWeight: 600,
  color: (theme: Theme) => theme.palette.custom.OV.extended.Signature.color,
  backgroundColor: (theme: Theme) =>
    alpha(theme.palette.custom.OV.extended.Signature.color, CLOSURE_NOTE_TINT_OPACITY),
};

export const closureNoteRangeSx: SxProps<Theme> = {
  display: 'block',
  fontWeight: 500,
  color: (theme: Theme) => theme.palette.custom.OV.sys.onBackground,
};

export const closureNoteReopensSx: SxProps<Theme> = {
  display: 'block',
  fontWeight: 500,
  fontSize: '0.65625rem',
  marginTop: '0.125rem',
  color: (theme: Theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
};

export const hoursCardCaptionSx: SxProps<Theme> = {
  display: 'block',
  fontSize: '0.59375rem',
  fontWeight: 700,
  letterSpacing: '0.08em',
  textTransform: 'uppercase',
  margin: '0.125rem 0 0.25rem',
  color: (theme: Theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
};

export const hoursRowSx = (isToday: boolean): SxProps<Theme> => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  gap: '0.75rem',
  padding: '0.09375rem 0',
  fontSize: '0.71875rem',
  fontWeight: isToday ? 600 : 400,
  color: (theme: Theme) =>
    isToday
      ? theme.palette.custom.OV.sys.onBackground
      : theme.palette.custom.OV.sys.onSurfaceVariant,
});

export const hoursCardFooterSx: SxProps<Theme> = {
  display: 'block',
  marginTop: '0.4375rem',
  fontSize: '0.65625rem',
  color: (theme: Theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
};
